import { brand } from '@brand';

import { CheckoutClaimLayout } from './CheckoutClaimLayout';

// Set by the checkout claim screen just before it hands off to the sign-in
// link, so every loading state between paying and the welcome screen keeps
// showing the same "Setting up your account" screen instead of a bare
// "Loading…" page that looks stuck. Tab-scoped and short-lived.
// "system.post_checkout_setup.v1" in the house build (brand.storageKeyPrefix).
const KEY = `${brand.storageKeyPrefix}post_checkout_setup.v1`;
const TTL_MS = 3 * 60_000;

export function markPostCheckoutSetup() {
  try {
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* storage is optional; the plain loader still works */
  }
}

export function postCheckoutSetupActive(): boolean {
  try {
    const started = Number(sessionStorage.getItem(KEY));
    return started > 0 && Date.now() - started < TTL_MS;
  } catch {
    return false;
  }
}

export function clearPostCheckoutSetup() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* nothing to clear */
  }
}

/** The claim screen's own pending state, reused until the portal is ready. */
export function PostCheckoutSetupScreen() {
  return (
    <CheckoutClaimLayout
      pending
      title="Confirming your order…"
      message="We're setting up your account. This usually takes a few seconds."
    />
  );
}
